import { useState, useEffect, useCallback, useRef } from 'react';

type ApiCall<T> = (
  ...args: any[]
) => Promise<{
  data: T | null;
  error: string | null;
  statusCode?: number | null;
}>;

export const useFetchData = <T,>(apiCall: ApiCall<T>, args: any[] = [], enabled = true) => {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [statusCode, setStatusCode] = useState<number | null>(null);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await apiCall(...args);
        if (response.error) {
          setError(response.error);
        } else {
          setData(response.data);
        }
        setStatusCode(response.statusCode || null);
      } catch (err) {
        setError('Failed to fetch data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [apiCall, JSON.stringify(args), enabled]);

  return { data, loading, error, statusCode };
};
